import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function isEmailVerificationError(error: string | null, description: string | null) {
  const combined = `${error ?? ""} ${description ?? ""}`.toLowerCase();
  return (
    combined.includes("email_not_verified") ||
    combined.includes("verify your email") ||
    combined.includes("email is not verified") ||
    combined.includes("email not verified")
  );
}

export default function Auth0VerificationRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const error = params.get("error");
    const description = params.get("error_description");

    if (!isEmailVerificationError(error, description)) return;

    const nextParams = new URLSearchParams();
    nextParams.set("reason", "email_not_verified");
    const returnTo = params.get("state") ? "/dashboard" : location.pathname || "/dashboard";
    nextParams.set("returnTo", returnTo);

    navigate(`/auth/check-email?${nextParams.toString()}`, { replace: true });
  }, [location.pathname, location.search, navigate]);

  return null;
}
